import { render } from "./RepeatableField.vue?vue&type=template&id=7b634ff0"
import script from "./RepeatableField.vue?vue&type=script&setup=true&lang=js"
export * from "./RepeatableField.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/RepeatableField.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b634ff0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b634ff0', __exports__)) {
    api.reload('7b634ff0', __exports__)
  }
  
  module.hot.accept("./RepeatableField.vue?vue&type=template&id=7b634ff0", () => {
    api.rerender('7b634ff0', render)
  })

}


export default __exports__